import { useState, useEffect } from "react";

const useQuotesForm = (initialFormValues, callback, validate) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };

  const clearForm = () => {
    setInputs(initialFormValues);
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    handleSubmit,
    inputs,
    clearForm,
    errors,
  };
};

export default useQuotesForm;
